module.exports = __webpack_public_path__ + "img/format_textdirection_l_to_r.e813b9c5.svg";